// Share image for a free tool: tool name or band only, never answers or scores
export const toolCardBlob = ({ line, sub, emoji, bg = "#F3EEFC", ink = "#2E2546" }) => new Promise((resolve, reject) => {
  const c = document.createElement("canvas");
  c.width = c.height = 1080;
  const x = c.getContext("2d");
  const font = getComputedStyle(document.body).fontFamily || "sans-serif";
  const g = x.createLinearGradient(0, 0, 1080, 1080);
  g.addColorStop(0, "#F3EEFC"); g.addColorStop(1, "#E8F4F8");
  x.fillStyle = g; x.fillRect(0, 0, 1080, 1080);
  x.fillStyle = bg; x.beginPath(); x.roundRect(80, 80, 920, 920, 64); x.fill();
  x.textAlign = "center"; x.textBaseline = "middle"; x.fillStyle = ink;
  x.font = `200px ${font}`; x.fillText(emoji, 540, 380);
  x.font = `bold 66px ${font}`; x.fillText(line, 540, 600, 860);
  x.font = `40px ${font}`; x.globalAlpha = 0.75; x.fillText(sub, 540, 690, 860);
  x.globalAlpha = 1; x.fillStyle = "#7C5CBF"; x.font = `600 36px ${font}`; x.fillText("Free calm tools · Mindful Me", 540, 910, 860);
  c.toBlob((b) => (b ? resolve(b) : reject(new Error("Couldn't create the image"))), "image/png");
});
